<script setup lang="ts">

</script>

<template>
  <div class="events-list-empty">
    <p class="events-list-empty__title">
      Новые мероприятия скоро появятся,
      <br>
      а пока что вы можете <a href="https://lcdp.xsquare.ru/" target="_blank" class="link">ознакомиться с платформой</a>,
      <br>
      <a class="link" href="https://xsquare.ru/docs/">изучить документацию</a>,
      либо перейти на <a class="link" href="https://xsquare.ru/demo/">демо-стенд</a><br>
    </p>
  </div>
</template>

<style scoped lang="scss">

</style>